import React, {useState, useEffect} from 'react';
import {connect} from "react-redux";
import {
    resetState,
    setSelectedPackage,
  init, execute, steps, popUpTypes, closePopUp,
  fillSignUpFormFields
} from "./IdfNewPlanSignupSlice"
import Header from "app/Components/Block/IdfSaleBlock/Constans/Header";
import SummaryStep from "app/Components/Block/IdfNewPlanSignupBlock/steps/SummaryStep";
import SelectionStep from "app/Components/Block/IdfNewPlanSignupBlock/steps/SelectionStep";
import AgreementsStep from "app/Components/Block/IdfNewPlanSignupBlock/steps/AgreementsStep";
import PopUp from "app/Components/Shared/Popup/PopUp";
import SignupFormPopUp from "app/Components/Block/IdfNewPlanSignupBlock/popUps/SignupFormPopUp";
import ConfirmationStep from 'app/Components/Block/IdfNewPlanSignupBlock/steps/ConfirmationStep';

const IdfNewPlanSignup = (props) => {

  useEffect(() => {
    if (props.userData?.loginData?.userDetails?.contactNumber !== undefined && !props.idfNewPlanSignup.loaded) {
      initProcess();
    }
    return () => {
      props.resetState();
    };
  }, [props.userData?.loginData?.userDetails]);

  const initProcess = async () => {
    await props.init(props.userData?.loginData?.userDetails?.contactNumber);
    props.fillSignUpFormFields({
      fullName: props.userData?.loginData?.userDetails?.firstName + ' ' + props.userData?.loginData?.userDetails?.lastName,
      id: props.userData?.loginData?.userDetails?.IDNumber,
      last4digits: props.userData?.loginData?.userDetails?.IdfIdNumber
    });
  }

    function renderStep() {
        switch (props.idfNewPlanSignup.currentStep) {
            case steps.SELECTION:
                return <SelectionStep iContent={props.iContent}/>
            case steps.AGREEMENTS:
                return <AgreementsStep iContent={props.iContent}/>
          case steps.CONFIRMATION:
            return <ConfirmationStep iContent={props.iContent} />;
            case steps.SUMMARY:
                return <SummaryStep/>
            default:
              return <SelectionStep iContent={props.iContent} />;
        }
    }

    function isSelectionStep() {
        return props.idfNewPlanSignup.currentStep === steps.SELECTION;
    }

    function getPopUp() {
        switch (props.idfNewPlanSignup.currentPopUp) {
            case popUpTypes.SIGNUP_FORM:
                return <SignupFormPopUp props={props}/>
            default:
              return <SignupFormPopUp props={props} />;
        }
    }

    return (
        <>
          <Header onClickBack={() => window.history.back()} hideBackButton={props.idfNewPlanSignup.currentStep === steps.SUMMARY}/>
          {props.idfNewPlanSignup.loaded &&
            <div className={`idf-new-plan-signup-main-container ${(isSelectionStep() ? '' : 'white-background')}`}>
              {renderStep()}
              <PopUp
                showPopUp={props.idfNewPlanSignup.displayPopUp}
                onClose={props.closePopUp}>
                {getPopUp()}
              </PopUp>
            </div>
          }
        </>
    );
}

const mapStateToProps = (state) => {
  return {
    idfNewPlanSignup: state.idfNewPlanSignup,
    userData: state.authentication
  };
};

const mapDispatchToProps = {
  resetState,
  setSelectedPackage,
  init,
  execute,
  closePopUp,
  fillSignUpFormFields
};

export default connect(mapStateToProps, mapDispatchToProps)(IdfNewPlanSignup);
